import React from 'react'
import {
  CloseCircleFilled,
  InfoCircleFilled,
  MailTwoTone,
  SoundFilled,
  WarningFilled,
  WechatFilled,
} from '@ant-design/icons'

import { Slide, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const ToastContainerWrapper = ({ toastContainerProps }) => {
  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return (
          <span>
            <WechatFilled />
          </span>
        )
      case 'error':
        return (
          <span>
            <CloseCircleFilled />
          </span>
        )
      case 'warning':
        return (
          <span>
            <WarningFilled />
          </span>
        )
      case 'info':
        return (
          <span>
            <InfoCircleFilled />
          </span>
        )
      default:
        return (
          <span>
            <SoundFilled />
          </span>
        )
    }
  }

  return (
    <ToastContainer
      {...toastContainerProps}
      icon={({ type }) => getIcon(type)}
    />
  )
}

// Set default props for ToastContainerWrapper
ToastContainerWrapper.defaultProps = {
  toastContainerProps: {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    newestOnTop: true,
    closeOnClick: false,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    transition: Slide,
  },
}

export default ToastContainerWrapper
